import React from 'react';

import { Box, Typography } from '@material-ui/core';

import ColoredButton from 'components/ColoredButton';

import useStyles from '../ProcessingActivitiesAssetReviewsPage/ProcessingActivitiesAssetReviewsPage.styles';

type QueryUnavailableStateProps = {
  backLabel: string;
  message: string;
  onBack: () => void;
};

const QueryUnavailableState: React.FC<QueryUnavailableStateProps> = ({ backLabel, message, onBack }) => {
  const styles = useStyles();

  return (
    <Box className={styles.errorBanner}>
      <Typography color='textSecondary' variant='body2'>
        {message}
      </Typography>
      <div className={styles.centeredPageActions}>
        <ColoredButton
          className=''
          customColor='grey'
          disabled={false}
          icon={false}
          onClick={onBack}
          showLoader={false}
          textLike={false}
          variant='outlined'
        >
          {backLabel}
        </ColoredButton>
      </div>
    </Box>
  );
};

export default QueryUnavailableState;
